var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { CameraModel } from '../../engine/models/camera.model';
import { LabelModel } from './labels/label.model';
import { Type, Exclude, Expose } from 'class-transformer';
import { SynchronizationModel } from './synchronization.model';
import { ChapterGraphModel } from './chapter-graph.model';
import { BackgroundModel } from 'src/app/engine/models/background.model';
const ɵ0 = () => LabelModel, ɵ1 = () => SynchronizationModel, ɵ2 = () => CameraModel, ɵ3 = () => ChapterGraphModel;
/* The Chapter model as it pertains to the application The engine is responsible
for building animation timelines and sychronizing the state of the scene-graph
at the start of each chapter. This data is stored in the Human Engine's chapter
object.

Engine responsibilities for faithfully setting chapter state include 1 - graph
synchronization. the state of each object in the scene-graph 2 - clipping
planes. These must be in effect simultaneously with the graph synchronization,
or else flashing may occur. 3 - camera position and action. 4 - lights.

Engine responsibilities for building chapter 1- building of the animations and
the corresponding timeline maps to map chapter time to animation time

However, the engine's chapter object stores several data attributes that it need
not be responsible for managing. Examples include: 1 - background color 2 - meta
data, display name and description 3 - labels (however, they do contain
engine-specific data for tracking points in space via markers) 4 - customData -
special, protected location scoped on the chapter for custom or in-development
features.

NOTE: EXCLUDE/EXPOSE
The human chapter object contains many properties that we do not want exposed to the application.
We use @Exclude/@Expose decorators to insist that only the @Expose'd properties are passed to the application state.

*/
let ChapterModel = class ChapterModel {
};
__decorate([
    Type(ɵ0),
    Type(ɵ1),
    Type(ɵ2),
    Type(ɵ3)
    // Shared Data between Human Chapter and App Chapter ---------------------
    ,
    Expose(),
    __metadata("design:type", String)
], ChapterModel.prototype, "id", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], ChapterModel.prototype, "info", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Array)
], ChapterModel.prototype, "labels", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Array)
], ChapterModel.prototype, "hotspots", void 0);
__decorate([
    Expose(),
    __metadata("design:type", SynchronizationModel)
], ChapterModel.prototype, "synchronization", void 0);
__decorate([
    Expose(),
    __metadata("design:type", BackgroundModel)
], ChapterModel.prototype, "background", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], ChapterModel.prototype, "lights", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Array)
], ChapterModel.prototype, "timelineMap", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], ChapterModel.prototype, "camera", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], ChapterModel.prototype, "properties", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Boolean)
], ChapterModel.prototype, "loop", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], ChapterModel.prototype, "customData", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], ChapterModel.prototype, "clippingPlanes", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], ChapterModel.prototype, "ui", void 0);
__decorate([
    Expose(),
    __metadata("design:type", ChapterGraphModel)
], ChapterModel.prototype, "graph", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], ChapterModel.prototype, "viewModes", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], ChapterModel.prototype, "recipes", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], ChapterModel.prototype, "transparencyMode", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], ChapterModel.prototype, "fallbackTransparency", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], ChapterModel.prototype, "effects", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], ChapterModel.prototype, "environment", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], ChapterModel.prototype, "options", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], ChapterModel.prototype, "media", void 0);
ChapterModel = __decorate([
    Exclude()
], ChapterModel);
export { ChapterModel };
export { ɵ0, ɵ1, ɵ2, ɵ3 };
